import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { updateIsCanvasFromMilestone, updateIsCanvasFrom } from '../MilestoneSlice';
import moment from "moment";
import { t } from "i18next";
import Select, { StylesConfig } from 'react-select';
import { formatDateWithDateAndMonthName, getPageSizeArray, setItemStatus, paginationStyles, getValueFromResource, FormatInvoiceDecimalNumber, formatDateTimeWithTZ, formatCurrntDateTime } from '../../../common/timeLiveFunction';
import { getTimeFromDecimal } from '../../../common/timesheetFunction';
import CustomPagination from "../../../common/Pagination";
import clsx from "clsx";
import { Dropdown } from 'react-bootstrap';
import Loader from '../../../common/Loader';
import { ShowToast } from "../../../common/Toastr";
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getProjectTaskList, updateAccountProjectTaskStatus, updateIsLoading, updateSearchPagination, updatePagination, checkedAllState,
  unCheckedAllState, checkedState, unCheckedState, deleteSelectedAccountProjectTasks, updateAccountProjectTaskId, deleteAccountProjectTask, updateSorting,
  updateNextPage,
  updateAccountProjectTaskIdFromList
} from "../TasksSlice";
import { useDebounce } from '../../../_metronic/helpers';
import PageSizeSelect from "../../../common/PageSizeSelect";
import MoveTask from "./MoveTask";
import { Tooltip } from "react-tooltip";
import infoSVG from "../../../assets/image/info-SVG.svg";
// import { Tooltip as ReactTooltip } from 'react-tooltip';
// import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";

const initialValuesForPermissions = {
  IsTaskTeam: false,
  IsEditTaskTeam: false,
  IsDeleteTaskTeam: false,
  permissionList: []
}

const TaskList = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const fromValue = queryParams.get('from');
  const { projectTaskList, timeEntryFormat, startRec, pageSize, pageNo, search, totalItems, isSearch, isLoading, isReload, accountProjectId, sortOrder, sortColumn, isParentTask, nextPage, isReloadFromMoveTask } = useAppSelector((state) => state.tasks);
  const { isCanvasFromMilestone, isCanvasFrom } = useAppSelector((state) => state.milestone);
  const { cultureInfoName, maxMenuHeight, allowMoveTask, decimalFormat,timeZoneName } = useAppSelector((state) => state.globalState);
  //const { ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId } = props.obj;
  //const { customMenuList } = useAppSelector((state) => state.globalState);
  const { ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId, IsEditTask, IsDeleteTask } = props.obj;
  const { allocationHoursInProjectTaskTeam } = useAppSelector((state) => state.project);
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
  const [newPageSize, setNewPageSize] = useState(pageSize);
  const [pageNumber, setPageNumber] = useState(pageNo);
  // const [hoveredColumn, setHoveredColumn] = useState(null);
  const moveTaskRef = useRef<any>(null);
  const [moveTaskModal, setMoveTaskModal] = useState(false);
  const [moveProjectTaskId, setMoveProjectTaskId] = useState(0);
  const [showCompletedTask, setShowCompletedTask] = useState(() => {
    return localStorage.getItem('showCompletedTask') === 'true';
  });
  const showItems = fromValue === 'projectTemplate'

  useEffect(() => {
    dispatch(getProjectTaskList())
      .unwrap()
      .then((originalPromiseResult) => {
        setIsFirstTimeLoad(false);
        dispatch(updateNextPage(true))
      })
      .catch((rejectedValueOrSerializedError) => {
      })
  }, [pageNo, pageSize, isReload, isReloadFromMoveTask]);

  const onHandleSearch = (event: any) => {
    let objects = {
      "startRec": 0,
      "pageSize": pageSize,
      "pageNo": 1,
      "search": event.target.value
    }
    dispatch(updatePagination(objects));
    // dispatch(updateSearchPagination(event.target.value));
  }

  const debouncedSearchTerm = useDebounce(search, 500);
  useEffect(() => {
    if (!isFirstTimeLoad) {
      dispatch(getProjectTaskList());
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (moveTaskModal) {
      if (moveTaskRef.current) {
        moveTaskRef.current.click();
      }
    }
  }, [moveTaskModal]);

  const onHandlePageSizeChange = (selectedOption: any) => {
    setNewPageSize(selectedOption.value);
    let objects = {
      "startRec": 0,
      "pageSize": selectedOption.value,
      "pageNo": 1,
      "search": search
    }
    dispatch(updatePagination(objects));
  }

  const onHandlePageChange = (pageNumber: any) => {
    let objects = {
      "startRec": (pageNumber - 1) * Number(newPageSize),
      "pageSize": newPageSize,
      "pageNo": pageNumber,
      "search": search
    }
    if (nextPage) {
      dispatch(updatePagination(objects));
      dispatch(updateNextPage(false))
    }
  }

  const handleSelectAllChange = (e: any) => {
    const { checked } = e.target;
    if (checked) {
      dispatch(checkedAllState());
    } else {
      dispatch(unCheckedAllState());
    }
  }

  const handleCheckboxChange = (e: any, rowId: any) => {
    if (e.target.checked) {
      dispatch(checkedState(rowId))
    } else {
      dispatch(unCheckedState(rowId))
    }
  }

const onDeleteSelectedRecords = () => {
    const tempDeletedArray = projectTaskList
        .filter(item => item.isSelected == 1)
        .map(item => item.AccountProjectTaskId);

    if (tempDeletedArray.length === 0) return;
    ShowSwalWithConfirmation('Are you sure you want to delete this record?', "").then((confirmed) => {     
        if (!confirmed) return;

        dispatch(updateIsLoading(true));
        dispatch(deleteSelectedAccountProjectTasks(tempDeletedArray.toString()))
            .unwrap()
            .then((res) => {
                if (Number(res.id) > 0) {
                    const count = tempDeletedArray.length;
                    ShowToast('Success', `${count} Task${count > 1 ? 's' : ''} Deleted Successfully.`, "success", "toast-top-right", 300, 300, 7000);
                } else {
                    ShowToast('Error', res.message, "error", "toast-top-right");
                }
            })
            .catch(() => {});
    });
};



  const deleteAccountProjectTaskById = (id: number) => {
    ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
      .then((result) => {
        if (result) {
          dispatch(updateIsLoading(true));
          dispatch(deleteAccountProjectTask(id)).then((result) => {
            dispatch(getProjectTaskList())
            Number(result.payload.id) > 0 ?
              ShowToast('Success', 'Task Deleted Successfully!', "success", "toast-top-right", 300, 300, 7000) :
              ShowToast('error', 'Task Delete Failed!', "error", "toast-top-right");
          })
            .catch((error) => {
            })
        }
      })
      .catch((error) => {
      });
  }

  const onHandleChangeStatus = (e: any, id: any) => {
    const { checked } = e.target;
    let Object = { 'IsDisabled': (checked ? true : false), 'AccountProjectTaskId': id }
    dispatch(updateIsLoading(true));
    dispatch(updateAccountProjectTaskStatus(Object)).then((result) => {
      Number(result.payload.id) > 0 ?
        ShowToast('Success', "Task Update Successfully", "success", "toast-top-right") :
        ShowToast('Error', result.payload.message, "error", "toast-top-right");
    }).catch((error) => {
    })
  }

  const navigateToAccountProjectTaskSummary = (obj: any) => {
    localStorage.setItem('objTask', JSON.stringify(obj));
    if (fromValue === 'projectTemplate') {
      navigate(`/accountprojecttasksummary/${obj.AccountProjectId}/${obj.AccountProjectTaskId}?from=projectTemplateTask`);
    } else {
      navigate(`/accountprojecttasksummary/${obj.AccountProjectId}/${obj.AccountProjectTaskId}`);
    }
    //navigate('/accountprojecttasksummary', { state: { obj } });
  }

  const navigateToTaskHoursRequest = (obj: any) => {
    navigate('/taskrequesthours', { state: { obj } });
  }

  const navigateToAudit = (AccountProjectTaskId: any) => {
    const obj = {
      Id: AccountProjectTaskId,
      TableName: 'AccountProjectTask',
      Title: getValueFromResource('Project Task Audit', dispatch, t)
    }
    // navigate('/accountaudit', { state: { obj } });
    navigate(`/accountaudit/${AccountProjectTaskId}`, { state: { obj } })

  }

  const onHandleSorting = (sortOrder: string, sortColumn: string) => {
    let objects = {
      "sortOrder": sortOrder,
      "sortColumn": sortColumn
    }
    dispatch(updateSorting(objects));
  }

  // const handleMouseEnter = (columnIndex: any) => {
  //   setHoveredColumn(columnIndex);
  // }

  // const handleMouseLeave = () => {
  //   setHoveredColumn(null);
  // }


  const handleOpenEditCanvas = (taskId: number) => {
    dispatch(updateIsCanvasFrom(getValueFromResource('Task', dispatch, t)));
    dispatch(updateAccountProjectTaskId(taskId));
    setTimeout(() => {
      const drawerBtn = document.getElementById('kt_OffCanvas');
      if (drawerBtn) {
        drawerBtn.click();
      }
    }, 100);
  };


  return (
    <>
      {isLoading && <Loader />}
      <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top bg-white">
          <h3 className="card-title fw-bold headerTitle">
            {/* {t('Task List')} */}
            {getValueFromResource('Task List', dispatch, t)}
          </h3>
          <div className="card-toolbar align-items-center">
            <div className="d-flex align-items-center gap-2">
              <span
                className="text-muted"
                style={{fontSize: '13px',lineHeight: '1',whiteSpace: 'nowrap'}}
              >
                {getValueFromResource('Show Completed Task:', dispatch, t)}
              </span>

              <div className="form-check form-switch form-check-custom mb-0">
                <input
                  type="checkbox"
                  className="form-check-input custom-padding-right h-15px w-30px"
                  checked={showCompletedTask}
                  onChange={(e) => {
                    const value = e.target.checked;
                    setShowCompletedTask(value);
                    localStorage.setItem('showCompletedTask', value.toString());
                  }}
                />
              </div>

              <div className="bullet bg-secondary h-35px w-1px mx-3"></div>
            </div>
            <div className="position-relative">
              <input
                type="text"
                value={search}
                onChange={onHandleSearch}
                placeholder=
                // {t('Search')}
                {getValueFromResource('Search', dispatch, t)}
                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                data-kt-user-table-filter="search"
              />
              <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            </div>
            <div className='h-35px w-1px mx-1'></div>
            <div className="d-flex align-items-center">
              {/* <Select
                styles={paginationStyles}
                maxMenuHeight={maxMenuHeight}
                options={getPageSizeArray()}
                value={getPageSizeArray().find((option: any) => option.value == pageSize)}
                onChange={onHandlePageSizeChange}
                className='fs-7 fw-normal'
              /> */}
              <PageSizeSelect onChange={onHandlePageSizeChange} />

            </div>
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            <div>
              {/* {(projectTaskList.length > 0) ? ( */}
              {(Number(totalItems) > 0) ? (
                <CustomPagination
                  currentPage={pageNo}
                  onPageChange={onHandlePageChange}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  start={startRec}
                  t={t}
                >
                </CustomPagination>
              ) : null}
            </div>
            <>
              <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ display: projectTaskList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}></div>
              <div className="text-muted me-5" style={{ marginRight: '2px', display: projectTaskList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                <span className="me-2" data-kt-user-table-select="selected_count">{projectTaskList.filter((item: any) => item.isSelected === 1).length}</span>
                {/* {t('Selected')} */}
                {getValueFromResource('Selected', dispatch, t)}
              </div>
              {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 32)[0].IsDelete && */}
              {IsDeleteTask &&
                <button type="button" className="btn btn-danger btn-sm"
                  onClick={() => { onDeleteSelectedRecords() }}
                  style={{ marginRight: '2px', display: projectTaskList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                >
                  <i className="bi bi-trash fs-5 me-2"></i>
                  {/* {t('Delete')} */}
                  {getValueFromResource('Delete', dispatch, t)}

                </button>}
            </>
          </div>
        </div>
        {/* <div className='card-body py-3'> */}
        <div className='card-Report-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
              <thead>
                <tr className='thHeading align-middle'>
                  {IsDeleteTask &&
                    <th className='w-25px'>
                      <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          checked={projectTaskList.every((item: any) => item.isSelected === 0) ? false :
                            (projectTaskList.every((item: any) => item.isSelected === 1 ? true : false))
                          }
                          onChange={handleSelectAllChange}
                        />
                      </div>
                    </th>
                  }
                  {IsEditTask &&
                    <th style={{ width: '10%' }}
                    // onMouseEnter={() => handleMouseEnter(1)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Active / InActive")} */}
                      {getValueFromResource('Active / Inactive', dispatch, t)}
                      {sortColumn === 'IsDisabled' ?
                        sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "IsDisabled") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "IsDisabled") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 1 && 
                        <><span className="cursor" onClick={() => { onHandleSorting("asc", "IsDisabled") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleSorting("desc", "IsDisabled") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>
                  }
                  <th style={{ width: '22%' }}>
                    {/* {t("Task Name")} */}
                    {getValueFromResource('Task Name', dispatch, t)}
                    {isParentTask ? (
                      // Lock icon for parent tasks
                      <span className="cursor">
                      </span>
                    ) : (
                      // Sorting logic for non-parent tasks
                      sortColumn === 'Orig_TaskName' ? (
                        <span
                          className="headerSortIconBG cursor"
                          onClick={() => onHandleSorting(sortOrder === 'asc' ? 'desc' : 'asc', 'Orig_TaskName')}
                          title={`Sort ${sortOrder === 'asc' ? 'descending' : 'ascending'}`}
                        >
                          <i className={`ki-outline ${sortOrder === 'asc' ? 'ki-arrow-up' : 'ki-arrow-down'} sortIconColor fs-5 sortMT`}></i>
                        </span>
                      ) : (
                        <>
                          <span
                            className="cursor"
                            onClick={() => onHandleSorting('asc', 'Orig_TaskName')}
                            title="Sort ascending"
                          >
                            <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                          </span>
                          <span
                            className="cursor"
                            onClick={() => onHandleSorting('desc', 'Orig_TaskName')}
                            title="Sort descending"
                          >
                            <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                          </span>
                        </>
                      )
                    )}
                  </th>                 
                  <th style={{ width: '12%' }}
                  // onMouseEnter={() => handleMouseEnter(3)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Date")} */}
                    {getValueFromResource('Date', dispatch, t)}
                    {sortColumn === 'DeadlineDate' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "DeadlineDate") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "DeadlineDate") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 3 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "DeadlineDate") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "DeadlineDate") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '13%' }}
                  // onMouseEnter={() => handleMouseEnter(4)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Status")} */}
                    {getValueFromResource('Status', dispatch, t)}
                    {sortColumn === 'Status' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "Status") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "Status") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 4 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "Status") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "Status") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '10%' }}
                  // onMouseEnter={() => handleMouseEnter(5)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Hours")} */}
                    {getValueFromResource('Hours', dispatch, t)}
                    {sortColumn === 'TotalHours' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "TotalHours") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "TotalHours") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 5 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "TotalHours") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "TotalHours") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '15%' }}
                  // onMouseEnter={() => handleMouseEnter(6)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Progress")} */}
                    {getValueFromResource('Work Progress (%)', dispatch, t)}
                    {sortColumn === 'Orig_CompletedPercent' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "Orig_CompletedPercent") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "Orig_CompletedPercent") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 6 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "Orig_CompletedPercent") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "Orig_CompletedPercent") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
<th style={{ width: '15%', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle', overflow: 'visible' }}>
    <div className="d-flex align-items-center justify-content-center gap-2">
        <div className="d-flex align-items-center gap-1">
            

            <span>{getValueFromResource('Last Updated', dispatch, t)}</span>
            <div
                style={{ marginBottom: "2px", cursor: "pointer" , maxWidth: '250px', whiteSpace: 'normal'}}
                data-tooltip-id="tooltip-organization"
                data-tooltip-place="top"
                          data-tooltip-content={getValueFromResource(
                            `During sorting, parent task dates automatically \nupdate based on the latest child task dates.`,
                            dispatch,
                            t
                          )}
            >
                <img
                    src={infoSVG}
                    alt=""
                    width={12}
                    height={12}
                    className="tooltip-info-icon"
                />
            </div>
        </div>

        <div>
            {sortColumn === 'RawLastUpdated' ? (
                <span
                    className="headerSortIconBG cursor"
                    onClick={(e) => {
                        e.stopPropagation();
                        onHandleSorting(
                            sortOrder === 'asc' ? "desc" : "asc",
                            "RawLastUpdated"
                        );
                    }}
                >
                    <i className={`ki-outline ${sortOrder === 'asc' ? 'ki-arrow-up' : 'ki-arrow-down'} sortIconColor fs-5 sortMT`}></i>
                </span>
            ) : (
                <>
                    <span
                        className="cursor me-1"
                        onClick={(e) => {
                            e.stopPropagation();
                            onHandleSorting("asc", "RawLastUpdated");
                        }}
                    >
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>

                    <span
                        className="cursor"
                        onClick={(e) => {
                            e.stopPropagation();
                            onHandleSorting("desc", "RawLastUpdated");
                        }}
                    >
                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>
                </>
            )}
        </div>
    </div>

  <Tooltip 
    id="tooltip-organization" 
    style={{ whiteSpace: 'pre-line', maxWidth: '300px', zIndex: 99999 }} 
   
/>
</th>
   
                   <th className='min-w-10px'>{t("")}</th>
                 
                </tr>
              </thead>
              <tbody>
                {/* {projectTaskList.length > 0 && projectTaskList.map((item: any) => { */}
                {projectTaskList.filter((item: any) => showCompletedTask ? item.Completed : item.Completed !== true).map((item: any) => {
                  return (
                    <tr key={item.AccountProjectTaskId}>
                      {IsDeleteTask &&
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              checked={item.isSelected == 0 ? false : true}
                              onChange={(e) => { handleCheckboxChange(e, item.AccountProjectTaskId) }}
                            />
                          </div>
                        </td>
                      }
                      <td className='text-center'>
                        <div className="form-check form-switch form-check-custom">
                          <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === false ? "Active" : "InActive"))}>
                            {item.IsDisabled === false ? "Active" : "InActive"}
                          </span>
                        </div>
                      </td>
                      {/* <td>
                        <a className='text-dark fw-bold d-block cursor'
                          onClick={() => {
                            navigateToAccountProjectTaskSummary({
                              "AccountProjectId": item.AccountProjectId,
                              "AccountProjectTaskId": item.AccountProjectTaskId,
                              "ProjectCode": ProjectCode,
                              "ProjectName": ProjectName,
                              "Status": Status,
                              "StartDate": StartDate,
                              "Deadline": Deadline,
                              "ProjectBillingRateTypeId": ProjectBillingRateTypeId
                            });
                          }}
                          style={{
                            paddingLeft: `${item.Level * 20}px`,  
                            textDecoration: item.IsParentTask ? 'underline' : 'none', 
                          }}
                        >
                          {item.Orig_TaskName}
                        </a>
                        <span
                          style={{
                            color: '#7b8ba6',
                            fontSize: 11,
                            paddingLeft: `${item.Level * 20}px`,  
                          }}>
                          {`Priority, ${item.Priority}`}
                        </span>
                      </td> */}

    {/* <td>
  <div className="task-row-container" style={{ paddingLeft: `${item.Level * 20}px` }}>
    <div className="d-inline-flex align-items-center flex-wrap">
      <a
        className='text-dark fw-bold cursor me-1'
        onClick={() => {
          navigateToAccountProjectTaskSummary({
            "AccountProjectId": item.AccountProjectId,
            "AccountProjectTaskId": item.AccountProjectTaskId,
            "ProjectCode": ProjectCode,
            "ProjectName": ProjectName,
            "Status": Status,
            "StartDate": StartDate,
            "Deadline": Deadline,
            "ProjectBillingRateTypeId": ProjectBillingRateTypeId
          });
        }}
        style={{ textDecoration: item.IsParentTask ? 'underline' : 'none' }}
      >
        {item.Orig_TaskName}
      </a>

{IsEditTask && (
  <button
  id="kt_OffCanvas"
    type="button"
    className="btn btn-icon btn-active-light-primary btn-sm p-0 h-20px w-20px task-edit-hover-icon ms-1"
    title={getValueFromResource('Edit Task', dispatch, t)}
    onClick={(e) => {
        dispatch(updateIsCanvasFrom('Task'));
        dispatch(updateAccountProjectTaskId(item.AccountProjectTaskId));

    }}
>
    <i className="bi bi-pencil-square fs-7 text-muted"></i>
</button>
)}

 </div>
    <div className="d-block">
      <span style={{ color: '#7b8ba6', fontSize: 11 }}>
        {`Priority, ${item.Priority}`}
      </span>
    </div>
  </div>
  <Tooltip id="tooltip-edit-task" style={{ zIndex: 99999 }} />
</td> */}
<td style={{ maxWidth: '300px' }}>
  <div className="task-row-container" style={{ paddingLeft: `${item.Level * 20}px` }}>
    
    <div className="d-flex align-items-center w-100">     
      <a
        className='text-dark fw-bold cursor me-1 text-truncate'
        onMouseEnter={(e) => {
          const target = e.currentTarget;
          if (target.scrollWidth > target.clientWidth) {
            target.setAttribute('data-tooltip-id', 'tooltip-full-taskname');
            target.setAttribute('data-tooltip-content', item.Orig_TaskName);
          } else {
            target.removeAttribute('data-tooltip-id');
            target.removeAttribute('data-tooltip-content');
          }
        }}
        onClick={() => {
          navigateToAccountProjectTaskSummary({
            "AccountProjectId": item.AccountProjectId,
            "AccountProjectTaskId": item.AccountProjectTaskId,
            "ProjectCode": ProjectCode,
            "ProjectName": ProjectName,
            "Status": Status,
            "StartDate": StartDate,
            "Deadline": Deadline,
            "ProjectBillingRateTypeId": ProjectBillingRateTypeId
          });
        }}
        style={{ 
          textDecoration: item.IsParentTask ? 'underline' : 'none',
          maxWidth: 'calc(100% - 24px)',
          display: 'inline-block'
        }}
      >
        {item.Orig_TaskName}
      </a>

      {IsEditTask && (
        <button
          id="kt_OffCanvas"
          type="button"
          className="btn btn-icon btn-active-light-primary btn-sm p-0 h-20px w-20px task-edit-hover-icon ms-1 flex-shrink-0"
          data-tooltip-id="tooltip-edit-task"
          data-tooltip-place="top"
          data-tooltip-content={getValueFromResource('Edit Task', dispatch, t)}
          onClick={(e) => {
            dispatch(updateIsCanvasFrom('Task'));
            dispatch(updateAccountProjectTaskId(item.AccountProjectTaskId));
          }}
        >
          <i className="bi bi-pencil-square fs-7 text-muted"></i>
        </button>
      )}

    </div>

    <div className="d-block">
      <span style={{ color: '#7b8ba6', fontSize: 11 }}>
        {`Priority, ${item.Priority}`}
      </span>
    </div>

  </div>

  <Tooltip 
    id="tooltip-edit-task" 
    style={{ fontWeight: 'normal', zIndex: 9999 }} 
  />

  <Tooltip 
    id="tooltip-full-taskname" 
    style={{ 
      fontWeight: 'normal', 
      zIndex: 9999, 
      maxWidth: '300px', 
      whiteSpace: 'normal', 
      wordBreak: 'break-word' 
    }} 
  />
</td>                

                      <td>
                        <a className='text-dark fw-bold d-block'>
                          <i className="ki-outline ki-calendar-2 fs-5 text-dark"></i>
                          {formatDateWithDateAndMonthName(item.DeadlineDate, cultureInfoName.toString())}
                        </a>
                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                          {getValueFromResource('Deadline Date', dispatch, t)}
                        </span>
                      </td>
                      <td>
                        <span  className={`badge fs-7 ${item.Status !== "Complete" && item.IsClosed === true ? "badge-light-success" : setItemStatus(item.Status)}`}>{item.Status}</span>
                        {/* <span className={`badge fs-7 ${setItemStatus(item.Status)}`}>{item.Status}</span> */}
                      </td>
                      <td>
                        <a className='text-gray-800 d-block'>
                          {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalHours, 2) : getTimeFromDecimal(item.TotalHours, false)}

                        </a>
                      </td>
                      <td className='text-center'>
                        <div className='d-flex flex-column w-100 me-2'>
                          <div className='d-flex flex-stack mb-2'>
                            <span className='text-muted me-2 fs-7 fw-semibold'>{`${FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.Orig_CompletedPercent, 2)}%`}</span>
                          </div>
                          <div className='progress h-6px w-100'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{ width: `${item.Orig_CompletedPercent}%` }}
                            ></div>
                          </div>
                        </div>
                      </td>
                     <td className="text-center position-relative">
    <div 
        className="group-hover-container d-inline-block"
        data-tooltip-id="tooltip-raw-date"
        data-tooltip-place="top"
         //data-tooltip-content={item.RawLastUpdated}         
         data-tooltip-content={formatCurrntDateTime(item.RawLastUpdated,cultureInfoName.toString())}
        // data-tooltip-content={formatDateWithDateAndMonthName(item.RawLastUpdated, cultureInfoName.toString())}
        style={{ cursor: 'pointer' }}
    >
        <span className='text-muted fs-7'>
            {item.LastUpdated}
        </span>
    </div>

    <Tooltip id="tooltip-raw-date" style={{ fontWeight: 'normal', zIndex: 9999 }} />
</td>
                     {/* <td className="text-center position-relative">
    <div className="group-hover-container" style={{ position: 'relative', display: 'inline-block' }}>
        <span className='text-muted fs-7 fw-semibold'>
            {item.LastUpdated}
        </span>
        
        <div className="custom-tooltip shadow-sm rounded px-2 py-1" style={{
            visibility: 'hidden',
            position: 'absolute',
            bottom: '125%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#ffffff',
            color: '#292929',           
            border: '1px solid #3f3f3f',
            whiteSpace: 'nowrap',
            fontSize: '11px',
            zIndex: 10,
            boxShadow: '0px 0px 10px rgba(0,0,0,0.1)'
        }}>
         
              {formatDateWithDateAndMonthName(item.RawLastUpdated, cultureInfoName.toString())}
           
        </div>
    </div>
</td> */}

{/* CSS style ko apni CSS file me add kar dein taake hover par visibility 'visible' ho jaye */}
{/* 
  .group-hover-container:hover .custom-tooltip {
      visibility: visible !important;
  }
*/}
                        {/* <td className='text-center'>
    <span className='text-muted fs-7 fw-semibold'>{item.LastUpdated}</span>
</td> */}
                      <td></td>
                      {/* {IsEditTask &&
                        <td className='text-center'>
                          <div className="form-check form-switch form-check-custom">
                             <input
                              type="checkbox"
                              className="form-check-input custom-padding-right h-15px w-30px"
                              checked={item.IsDisabled == true ? true : false}
                              onChange={(e) => { onHandleChangeStatus(e, item.AccountProjectTaskId) }}
                            />
                          </div>
                        </td>
                      }  */}
                      <td className='text-center'>
                        <Dropdown
                          style={{ marginLeft: 1 }}
                          className={clsx('cursor-pointer symbol')}
                          data-kt-menu-attach='parent'
                          data-kt-menu-placement='bottom-end'
                        >
                          <Dropdown.Toggle
                            variant="transparent"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("More")}
                            {getValueFromResource('More', dispatch, t)}
                            data-tooltip-place="top"
                          >
                            <i className="bi bi-three-dots fs-7"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                            {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 32)[0].IsEdit &&  */}
                            {IsEditTask &&
                              <div className='menu-hover-bg-sec'>
                              
                                <Dropdown.Item
                                  id="kt_OffCanvas"
                                  className="menu-item me-lg-0"
                                  onClick={() => {                                    
                                    dispatch(updateIsCanvasFrom(getValueFromResource('Task', dispatch, t)));
                                    dispatch(updateAccountProjectTaskId(item.AccountProjectTaskId))
                                  }}
                                >
                                  <span className="menu-icon custom-menu mb-2">
                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                      <span className="path1"></span>
                                      <span className="path2"></span>
                                    </i>
                                  </span>
                                  <span className="menu-title custom-menu-fontsize">
                                  
                                    {getValueFromResource('Edit', dispatch, t)}
                                  </span>
                                </Dropdown.Item>
                              </div>}
                            {allowMoveTask &&
                              <Dropdown.Item
                                className="menu-item me-lg-0"
                                onClick={() => {
                                  setMoveProjectTaskId(item.AccountProjectTaskId);
                                  setMoveTaskModal(true);
                                }}
                              >
                                <span className="menu-icon custom-menu mb-2">
                                  <i className="bi bi-arrows-move fs-4 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i>
                                </span>
                                <span className="menu-title custom-menu-fontsize">
                                  {getValueFromResource('Move Task', dispatch, t)}
                                </span>
                              </Dropdown.Item>
                            }
                            <div className='menu-hover-bg-sec'>
                              <Dropdown.Item
                                className="menu-item me-lg-0"
                                onClick={() => {
                                  navigateToAccountProjectTaskSummary({
                                    "AccountProjectId": item.AccountProjectId,
                                    "AccountProjectTaskId": item.AccountProjectTaskId,
                                    "ProjectCode": ProjectCode,
                                    "ProjectName": ProjectName,
                                    "Status": Status,
                                    "StartDate": StartDate,
                                    "Deadline": Deadline,
                                    "ProjectBillingRateTypeId": ProjectBillingRateTypeId
                                  });
                                }}
                              >
                                <span className="menu-icon custom-menu mb-2">
                                  <i className="bi bi-file-earmark-text fs-4 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i>
                                </span>
                                <span className="menu-title custom-menu-fontsize">
                                  {/* {`${t('View Task')}`} */}
                                  {getValueFromResource('View Task', dispatch, t)}
                                </span>
                              </Dropdown.Item>
                            </div>
                            {!showItems && <div className='menu-hover-bg-sec'>
                              <Dropdown.Item
                                className="menu-item me-lg-0 "
                                onClick={() => navigateToAudit(item.AccountProjectTaskId)}
                              >
                                <span className="menu-icon custom-menu mb-2">
                                  <i className="bi bi-receipt fs-6 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i>
                                </span>
                                <span className="menu-title custom-menu-fontsize">
                                  {/* {`${t('Audit')}`} */}
                                  {getValueFromResource('Audit', dispatch, t)}
                                </span>
                              </Dropdown.Item>
                            </div>}
                            {!showItems && allocationHoursInProjectTaskTeam &&
                              <div className='menu-hover-bg-sec'>
                                <Dropdown.Item
                                  className="menu-item me-lg-0"
                                  onClick={() => {
                                    navigateToTaskHoursRequest({
                                      "AccountProjectTaskId": item.AccountProjectTaskId
                                    });
                                  }}
                                >
                                  <span className="menu-icon custom-menu mb-2">
                                    <i className="bi bi-clock fs-4 iconColor">
                                      <span className="path1"></span>
                                      <span className="path2"></span>
                                    </i>
                                  </span>
                                  <span className="menu-title custom-menu-fontsize">
                                    {/* {`${t('Task Hours Request')}`} */}
                                    {getValueFromResource('Task Hours Request', dispatch, t)}
                                  </span>

                                </Dropdown.Item>
                              </div>}
                            {/* {customMenuList.length > 0 && customMenuList.filter((x: any) => x.Id == 32)[0].IsDelete && */}
                            {IsDeleteTask &&
                              <>
                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                <div className='menu-hover-bg-danger'>
                                  <Dropdown.Item
                                    className="menu-item me-lg-0"
                                    onClick={() => { deleteAccountProjectTaskById(item.AccountProjectTaskId) }}
                                  >
                                    <span className="menu-icon custom-menu mb-2">
                                      <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                      </i>
                                    </span>
                                    <span className="menu-title delete-menu custom-menu-fontsize">
                                      {/* {`${t('Delete')}`} */}
                                      {getValueFromResource('Delete', dispatch, t)}
                                    </span>
                                  </Dropdown.Item>
                                </div>
                              </>
                            }
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {projectTaskList.length === 0 &&
              <div className=''>
                <p className='noDataFound'>
                  {/* {t('No Record Found')} */}
                  {getValueFromResource('No Record Found', dispatch, t)}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
      {moveTaskModal && (
        <>
          <MoveTask
            isOpen={moveTaskModal}
            accountProjectTaskId={moveProjectTaskId}
            accountProjectTaskName={projectTaskList.filter((x: any) => x.AccountProjectTaskId === moveProjectTaskId)[0].Orig_TaskName}
            projectName={ProjectName}
            closeModal={() => setMoveTaskModal(false)}
          />
         {/* TaskList component ke standard return HTML ke aakhir me Add karein */}

        </>
      )}
    </>
  )
}

export default TaskList